var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vimeo",style:({height: _vm.height}),attrs:{"id":_vm.id}},[_c('iframe',{attrs:{"src":("" + _vm.fullUrl),"frameborder":"0","webkitallowfullscreen":"","mozallowfullscreen":"","allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }